import { render, staticRenderFns } from "./OnCall.vue?vue&type=template&id=330fc6b5"
import script from "./OnCall.vue?vue&type=script&lang=js"
export * from "./OnCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports